import { dictionaryCamelCaseConverter } from 'src/utils/dictionaryCamelCaseConverter';

export const sanitizeApaduaAnnouncements = (data) => dictionaryCamelCaseConverter(data);
